export const resolveProModePreviewDevice = (devices, previewDeviceId, activeDeviceId) => (
  devices.find((device) => device.id === previewDeviceId && device.is_connected)
  || devices.find((device) => device.id === activeDeviceId)
  || devices.find((device) => device.is_connected)
  || null
);

export const canSwitchProModePreview = ({
  isLive,
  previewDevice,
  activeDeviceId,
  transitionBusy,
}) => Boolean(
  isLive
  && previewDevice?.is_connected
  && previewDevice.id !== activeDeviceId
  && !transitionBusy
);
